/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpdatePluginForm = {
  /**
   * Updated description.
   */
  description?: string | undefined;
  id: string;
  /**
   * Updated display name.
   */
  name: string;
  /**
   * Updated slug.
   */
  slug: string;
};

/** @internal */
export type UpdatePluginForm$Outbound = {
  description?: string | undefined;
  id: string;
  name: string;
  slug: string;
};

/** @internal */
export const UpdatePluginForm$outboundSchema: z.ZodMiniType<
  UpdatePluginForm$Outbound,
  UpdatePluginForm
> = z.object({
  description: z.optional(z.string()),
  id: z.string(),
  name: z.string(),
  slug: z.string(),
});

export function updatePluginFormToJSON(
  updatePluginForm: UpdatePluginForm,
): string {
  return JSON.stringify(
    UpdatePluginForm$outboundSchema.parse(updatePluginForm),
  );
}
